function Scroll() {
	var self = this;
	self.init();
}

Scroll.prototype.init = function() {
	var self = this;
	self.handleScroll();
	self.handleHorizontalScroll();
	self.hendleStickyMenu();
	self.hendleLift();
};


Scroll.prototype.scrollTo = function(target) {
	var self = this,
		hh = 0;
	if ($('header').css('position') == "fixed")
		hh = $('header').height();

	if (typeof target !== "number") {
		if (typeof target === "string")
			target = $(target);
		target = target.offset().top;
	}

	if (typeof self.lenis !== "undefined") {
		self.lenis.scrollTo(target - hh);
	} else {
		window.scrollTo({top: target - hh, left: 0, behavior: "smooth"});
	}
};

Scroll.prototype.handleScroll = function() {
	var self = this;
	var timeout, updated, st;

	$(window).on('scroll wheel', function(e) { 
		st = $(this).scrollTop();
		if (st > updated) {
			$('body').removeClass('-scrolling--up').addClass('-scrolling--down');
		}
		else if (st < updated) {
			$('body').removeClass('-scrolling--down').addClass('-scrolling--up');
		}
		if (st > 100) {
			$('body').removeClass('-top');
		} else {
			$('body').addClass('-top');
		}
		updated = st;
		clearTimeout(timeout);
		timeout = setTimeout(function() {
			$('body').removeClass('-scrolling--down');
		}, 50);
	});

	function scrollFn(time) {
		self.lenis.raf(time);
		requestAnimationFrame(scrollFn);
	}

	if (!(app.browser == "safari" && $('html').hasClass('touch'))) {
		// Smooth scrolling initialization (using Lenis https://github.com/studio-freight/lenis)
		self.lenis = new Lenis({
			duration: 1.2,
			easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
			smooth: true,
			direction: 'vertical',
		});

		requestAnimationFrame(scrollFn);

		if (window.location.hash) {
			setTimeout(function() {
				self.scrollTo($(window.location.hash).offset().top);
			}, 1000);
		}
	}

	$('body').on('click', '[data-action="scrolldown-1x"]', function(e) {
		e.preventDefault();
		self.lenis.scrollTo(window.innerHeight, 1000);
	});
};

Scroll.prototype.handleHorizontalScroll = function() {

	if (app.mq > 5) {
		$('.history-wrapper .swiper-slide').css('width', $('.history-wrapper .history-container').innerWidth()+'px');
		var swiper = new Swiper('.history-wrapper .section-container', {
			slidesPerView: "auto",
			freeMode: true,
			mousewheel: false,
			longSwipesRatio: 0.25,
			navigation: {
				prevEl: '.slick-nav-arrow--prev',
				nextEl: '.slick-nav-arrow--next',
			},
		});
	}
};

Scroll.prototype.hendleStickyMenu = function() {
	let activateItem = function(item) {
		let span = item.find('span');
		item.addClass('-active').siblings().removeClass('-active');
		gsap.to(item.parent().find('.body-menu-items__border'), {scaleX: span.innerWidth(), x: span.offset().left});
	};

	$('body').on('click', '.body-menu a[href*="#"]', function(e) {
		activateItem($(this));
		app.scroll.scrollTo($($(this).attr('href')).offset().top - $('header').height());
	});

	const menuLinks = document.querySelectorAll('.body-menu a');
	const anchors = document.querySelectorAll('data[id]');

	const sectionObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const targetId = entry.target.getAttribute('id');

			if (entry.isIntersecting) {
				menuLinks.forEach((link) => link.classList.remove('-active'));

				menuLinks.forEach((link) => {
					if (link.getAttribute('href').substring(1) === targetId) {
						link.classList.add('-active');
						activateItem($(link));
					}
				});
			}
		});
	}, {root: null, rootMargin: '0px', threshold: 0});

	anchors.forEach((anchor) => {
		sectionObserver.observe(anchor);
	});
};

Scroll.prototype.hendleLift = function() {
	var self = this;
	$('body').on('click', '[data-action="scrolltop"]', function(e) {
		e.preventDefault();
		self.lenis.scrollTo(0);
	});
};